goog.provide('el8.ptdata.medOrders');

goog.require('el8.ptdata.model.med.medOrder');
goog.require('el8.ptdata.model.med.asMap');

goog.require('el8.model.base');
goog.require('el8.service.urls');
goog.require('el8.uiwidget.alert');
goog.require('el8.uiwidget.alertHTML');
goog.require('el8.data.referencedPracticians');

goog.require('el8.app.shared.dialog.epcsApprove');


el8.ptdata.medOrders = (function() {

    var that = new el8_EntitySet({
        model: el8.ptdata.model.med.medOrder,
        items: [],
        observable: true,
        defaultFetch: false,
        urlFn: function(id) { return el8.service.urls.get('medOrders', [id]); },
        sortFn: function(a, b) {
            if (a.getDisplayedMedicationName().toLowerCase() < b.getDisplayedMedicationName().toLowerCase()) { return -1; }
            if (a.getDisplayedMedicationName().toLowerCase() === b.getDisplayedMedicationName().toLowerCase()) { return 0; }
            return 1;
        },
        saveFn: function(item, successCb, errorCb, opts) {
            opts = opts || {};
            var mapped = el8.ptdata.model.med.asMap(item);
            $.el8_ajax({
                type: 'POST',
                url: el8.service.urls.get('medOrders', [item.getId()]),
                data: {'prescription': JSON.stringify(mapped)},
                async: (opts.async !== false), // defaults to true
                success: function(data) {
                    item.populate(data['med_order']);
                    if (data['thread']) {  // if signed off
                        el8.ptdata.medOrderThreads.create(data['thread']); // notifies
                    }
                    if (data['new_physician']) {
                        el8.data.referencedPracticians.create(data['new_physician']);
                    }
                    if (successCb) { successCb(); }
                },
                error: errorCb,
                error_override: function(data) {
                    if (data.status === 400) {
                        el8.uiwidget.alertHTML(JSON.parse(data.responseText).error);
                    } else {
                        el8.uiwidget.alert(el8.util.consts.DEFAULT_ERROR_MSG);
                    }
                }
            });
        },
        deleteFn: function(item, successCb, errorCb, opts) {
            opts = opts || {};
            el8.appservice.notifier.notify('Med order being deleted...');
            $.el8_ajax({
                type: "DELETE",
                url: el8.service.urls.get('medOrders', [item.getId()]),
                async: (opts.async !== false), // defaults to true
                success: function(data) {
                    if (item.isSignedOff()) {
                        if (data['deleted_thread_id']) {
                            el8.ptdata.medOrderThreads.remove(data['deleted_thread_id']);
                        }
                        if (data['updated_thread']) {
                            el8.ptdata.medOrderThreads.create(data['updated_thread']);
                        }
                        if (data['remove_visitnote_references']) {
                            el8.appchart.visitNote.main.removeNewOrder(item);
                        } else if (data['remove_nonvisitnote_references']) {
                            el8.appchart.nonvisitNote.main.removeNewOrder(item);
                        }
                    }
                    if (successCb) { successCb(); }
                    el8.appservice.notifier.notify('Med order deleted.');
                },
                error_override: function(data) {
                    if (data.status === 400) {
                        el8.uiwidget.alert(data.responseText);
                    } else {
                        el8.uiwidget.alert(el8.util.consts.DEFAULT_ERROR_MSG);
                    }
                }
            });
        }
    });

    function _standardizeRxList(list) {
        // ouputs a list of dicts with keys "id", "type", "item"
        // list can be:
        //   - a list of MedOrder items,
        //   - a list of dicts with keys "id" and "type", or
        //   - a list of MedOrder ids. In this case, all MedOrders
        //     assumed to be printed as prescriptions
        var stdList = [];
        var id, type, item, packaged_medication_id = null;
        for (var i=0; i<list.length; i++) {
            id = list[i].getId ? list[i].getId() :
                (list[i].id ? list[i].id : list[i]);

            type = list[i].isPrescription ?
                (list[i].getMedication().isControlled() ? 'controlled' :
                    (list[i].getNumSamples() ? 'samples' :
                        (list[i].getPrintType() || 'prescription'))) :
                (list[i].type ? list[i].type : 'prescription');

            packaged_medication_id = list[i].packaged_medication_id || null;

            // Get item if available
            item = list[i].getId ? list[i] : (list[i].item || null);

            stdList.push({
                id: id,
                type: type,
                item: item,
                packaged_medication_id: packaged_medication_id
            });
        }
        return stdList;
    }

    function _submitERx(stdList, pharmacy, serviceLocationId, callbackFn, printTab) {
        var data = [];
        // 'stdList' is a list of dicts with keys "id", "type", "item"
        if (stdList.length) {
            for (var i=0; i<stdList.length; i++) {
                var item = that.getById(stdList[i]['id']);
                data.push({
                    med_order_id: item.getId(),
                    pharmacy_ncpdpid: pharmacy ? pharmacy.getNcpdpid() : null,
                    packaged_medication_id: stdList[i]['packaged_medication_id'],
                    service_location_id: serviceLocationId
                });
            }
            var items = [];
            $.el8_ajax({
                type: 'POST',
                url: el8Globals['PATIENT_PATH']+'erx/prescriptions/',
                data: {'med_orders': JSON.stringify(data)},
                async: false,
                success: function(resp) {
                    for (var i=0; i<resp.length; i++) {
                        var item = that.getById(resp[i]['med_order_id']);
                        if (item) {
                            var opts = resp[i];
                            item.populate(opts['order']);
                            el8.ptdata.medOrders.trigger('updated', item);
                            items.push(item);
                        }
                    }
                    if (callbackFn) { callbackFn(); }
                    el8.ptdata.ptPreferences.refresh();
                },
                error: function() {
                    stdList.map(function(a) {
                        a.item.markERxState({
                            'state': 'error',
                            'detail': 'Failed to send ePrescription.',
                            'required': true
                        });
                    });
                    if (callbackFn) { callbackFn(); }
                }
            });
            if (items.length) {
                if (printTab) {
                    that.printCopy(items, printTab);
                }
                that.addERxPoller(items.map(function(a) { return a.getId(); }));
            }
        }
    }

    function _submitControlledERx(stdList, pharmacy, serviceLocationId, callbackFn) {
        // CS only for passing to MDT (doesn't print -- submit only)
        var data = [];
        if (stdList.length) {
            for (var i=0; i<stdList.length; i++) {
                var item = that.getById(stdList[i]['id']);
                data.push({
                    med_order_id: item.getId(),
                    pharmacy_ncpdpid: pharmacy ? pharmacy.getNcpdpid() : null,
                    packaged_medication_id: stdList[i]['packaged_medication_id'],
                    service_location_id: serviceLocationId
                });
            }

            var medOrderIds = _.pluck(data, 'med_order_id');

            $.el8_ajax({
                type: 'POST',
                url: el8.service.urls.get('mdtParamsWithPatient', [el8.ptdata.currPatient.getId()]),
                data: {'med_orders': JSON.stringify(data)},
                async: false,
                success: function(data) {
                    var resp = data.orders_rv ? data.orders_rv : [];
                    delete data.orders_rv;

                    var url = data.url;
                    delete data.url;

                    data.pid = el8.ptdata.currPatient.getId();
                    if (el8Globals.FEATURES.MDToolboxErrors && data.status_message) {
                        el8.uiwidget.alertHTML(data.status_message);
                    } else {
                        var page = el8Globals.FEATURES.NewSurescriptsEPCS ? 'signrxonly' : 'SignSendOnly';
                        el8.app.shared.dialog.epcsApprove.show({
                            // This shows the final "enter your PW and TFA code" screen which
                            // is what we want. 'RxSendCs' will show that with the meds summary
                            // screen behind it which is useful for testing
                            url: url + '?' + $.param($.extend({page: page}, data)),
                            medOrderIds: medOrderIds
                        });

                        for (var i = 0; i < resp.length; i++) {

                            var item = that.getById(resp[i]['med_order_id']);
                            if (item) {
                                // Not sure what we want to do with fills at this point,
                                // but trigger updates on the item
                                var opts = resp[i];
                                item.setFulfillmentRequired(false);
                                item.getFulfillmentMgr().loadFulfillments(opts['fulfillments']);
                                el8.ptdata.medOrders.trigger('updated', item);
                            }
                        }
                    }
                    if (callbackFn) { callbackFn(true); }
                    el8.ptdata.ptPreferences.refresh();
                },
                error: function() {
                    // Do nothing for now
                    if (callbackFn) { callbackFn(true); }
                },
                error_override: function(data) {
                    if (data.status === 400) {
                        el8.uiwidget.alertHTML(JSON.parse(data.responseText).error);
                    } else {
                        el8.uiwidget.alert(el8.util.consts.DEFAULT_ERROR_MSG);
                    }
                }
            });
        }
    }

    that.eRxSet = function(list, pharmacy, serviceLocationId, _callbackFn, doPrintCopy, orderDialogType) {
        // Helper function actually eRx a list of meds (and also optionally print)
        //
        // list can be:
        //   - a list of MedOrder items,
        //   - a list of dicts with keys "id" and "type", or
        //   - a list of MedOrder ids. In this case, all MedOrders
        //     assumed to be printed as prescriptions

        var stdList = _standardizeRxList(list);

        var toERx = [];
        var toERxControlled = [];
        var controlled = []; // these are medorders
        var erx = []; // these are medorders
        var id, type, item = null;
        var notifyToRefreshReqAct = false;   //If an order was fulfilled, we'll want to notify the set

        var callbackFn = function(hide_notification) {
            if (_callbackFn) { _callbackFn(hide_notification); }
            /* Notify to refresh req act */
            for (var i=0; i<stdList.length; i++) {
                var item = that.getById(stdList[i]['id']);
                if (item) {
                    el8.ptdata.medOrders.trigger('updated', item);
                }
            }
        };

        for (var i=0; i<stdList.length; i++) {
            id = stdList[i]['id'];
            type = stdList[i]['type'];
            item = that.getById(id);

            if (item && (item.isNeedsFulfillment() || item.getFulfillmentMgr().isLatestERxError())) {
                notifyToRefreshReqAct = true;
            }

            // Sort the list of meds into controlled substances and non-controlled
            // substances. Before, if there were controlled substances we would force
            // them to be printed. Now, allow them to be eRx'd
            if (item.getMedication().isControlled()) {
                controlled.push(item); // used for printing
                if (el8Globals.FEATURES.MDToolboxEPCS && el8.data.currUser.isEpcsEnabled()) {
                    toERxControlled.push(stdList[i]);
                }
            } else {
                erx.push(item);
                // if the order dialog form is controlled and user is enabled for
                // EPCS, we submit non-controlled substances as controlled substance
                // drugs to MDToolbox
                if (orderDialogType === 'controlled' &&
                    el8Globals.FEATURES.MDToolboxEPCS && el8.data.currUser.isEpcsEnabled()) {
                    toERxControlled.push(stdList[i]);
                } else {
                    toERx.push(stdList[i]);
                }
            }
        }
        var printTab = null;

        if (!el8Globals.FEATURES.MDToolboxEPCS || !el8.data.currUser.isEpcsEnabled()) {
            if (doPrintCopy) { printTab = window.open(); }
            if (controlled.length) {
                var printPath = el8.service.urls.get('printMeds', ['controlled', controlled]);
                el8.uiwidget.alert('You are prescribing '+controlled.length+' controlled medication(s), which cannot be electronically prescribed and will be printed instead. Please insert tamper-proof paper into the printer now before printing.',
                    null,
                    function() {
                        _submitERx(toERx, pharmacy, serviceLocationId, callbackFn, printTab);
                        window.open(printPath);
                    },
                    'Print now'
                );
            } else {
                _submitERx(toERx, pharmacy, serviceLocationId, callbackFn, printTab);
            }
        } else {
            // Submit non-CS
            if (toERx.length) {
                // note that we're not including printTab here since we will do one
                // print batch at the end of this call
                _submitERx(toERx, pharmacy, serviceLocationId, callbackFn);
            }

            if (toERxControlled.length) {
                // Should be prevented upstream, but adding sanity check here
                if (el8.data.currUser.isEpcsEnabled() &&
                    !el8.data.currUser.isOfficeStaff() &&
                    !el8.data.currUser.getRxDelegatingPhysicianIdsInWorkspace().length) {
                    // Submit to CS
                    _submitControlledERx(toERxControlled, pharmacy, serviceLocationId, callbackFn);
                }
            }
        }
        if (doPrintCopy) {
            that.printCopy(controlled.concat(erx), printTab);
        }
    };

    that.printSet = function(list, _callbackFn, isFax) {

        // list can be:
        //   - a list of MedOrder items,
        //   - a list of dicts with keys "id" and "type", or
        //   - a list of MedOrder ids. In this case, all MedOrders
        //     assumed to be printed as prescriptions

        var stdList = _standardizeRxList(list);

        var pathArgs = [];
        var anyControlled = false;
        var id, type, item = null;
        var notifyToRefreshReqAct = false;   //If an order was fulfilled, we'll want to notify the set

        var callbackFn = function() {
            /* Notify to refresh req act */
            for (var i=0; i<stdList.length; i++) {
                var item = that.getById(stdList[i]['id']);
                if (item) {
                    el8.ptdata.medOrders.trigger('updated', item);
                }
            }
            if (_callbackFn) { _callbackFn(); }
        };

        for (var i=0; i<stdList.length; i++) {

            id = stdList[i]['id'];
            type = stdList[i]['type'];

            item = that.getById(id);

            if (type === 'controlled') {
                anyControlled = true;
            }

            if (item) {
                if (!isFax) { item.markPrinted(); }
                else { item.markFaxed(); }
                notifyToRefreshReqAct = true;
            }

            pathArgs.push(id+"="+type);
        }
        if (pathArgs.length > 0) {
            var rxPrintPath = !isFax ?
                el8.service.urls.get('printMedOrders', [pathArgs]) :
                el8.service.urls.get('faxMedOrders', [pathArgs]);

            if (anyControlled) {
                el8.uiwidget.alert( 'You are prescribing a controlled medication.  Please insert tamper-proof paper into the printer before printing.',
                    null,
                    function() {
                        window.open(rxPrintPath, '_blank', 'noopener');
                        callbackFn();
                    },
                    'Print now'
                );
            } else {
                window.open(rxPrintPath, '_blank', 'noopener');
                callbackFn();
            }
        }
    };

    that.callInSet = function(orders) {
        // Expect 'orders' to be an array of medOrders
        if (!orders.length) { return; }
        var medOrderIds = orders.map(function(a) { return a.getId(); });
        $.el8_ajax({
            type: 'POST',
            url: el8.service.urls.get('callInMedOrders'),
            data: {'data': JSON.stringify({'med_order_ids': medOrderIds})},
            success: function(data) {
                for (var i=0; i<orders.length; i++) {
                    var order = orders[i];
                    order.getFulfillmentMgr().loadFulfillments(data[order.getId()]);
                    el8.ptdata.medOrders.trigger('updated', order);
                }
            }
        });
    };

    that.eRxSingle = function(order, pharmacy, selectedServiceLocationId, callbackFn, doPrintCopy) {
        that.eRxSet([order], pharmacy, selectedServiceLocationId, callbackFn, doPrintCopy);
    };

    that.printSingle = function(order, type, callbackFn, isFax) {
        if (type) {
            that.printSet([
                {id: order.getId(), type: type}
            ], callbackFn, isFax);
        } else {
            that.printSet([order], callbackFn, isFax);
        }
    };

    that.printCopy = function(orders, newTab) {
        var printPath = el8.service.urls.get('printERxCopy', [orders]);
        if (newTab) {
            newTab.location.href = printPath;
        } else {
            window.open(printPath, '_blank', 'noopener');
        }
    };

    that.dismissERxError = function(order, callbackFn) {

        var fulfillmentId = null;
        var latestERx = order.getFulfillmentMgr().getLatestERx();
        if (latestERx && latestERx.isError()) {
            fulfillmentId = latestERx.getId();
        } else if (order.getFulfillmentMgr().isLatestCancelRequiringAction()) {
            fulfillmentId = order.getFulfillmentMgr().getCurrentCancel().getId();
        }

        if (fulfillmentId) {
            $.el8_ajax({
                type: 'POST',
                url: el8.service.urls.get('dismissERxError',
                    [order.getId(), fulfillmentId]),
                success: function(data) {
                    order.populate(data);
                    el8.ptdata.medOrders.trigger('updated', order);
                    if (callbackFn) { callbackFn(); }
                }
            });
        }
    };

    that.dismissEOrderError = function(order, callbackFn) {
        /**
         * Figure out where this function belongs
         * And figure out if we should do any client validation
         * @type {null}
         */
        $.el8_ajax({
            type: 'POST',
            url: el8.service.urls.get('dismissEOrderError',
                [order.getId()]),
            success: function(data) {
                order.populate(data);
                el8.ptdata.labOrders.trigger('updated', order);
                if (callbackFn) { callbackFn(); }
            },
            error: function() { // Any user feedback here?
            }
        });
    };

    that.filterByThreadId = function(threadId) {
        var all = that.all();
        var result = [];
        for (var i=0; i<all.length; i++) {
            if (all[i].getThreadId() === threadId) {
                result.push(all[i]);
            }
        }
        return result;
    };

    /**
     * Polling for ePrescribing results
     */

    var POLL_INTERVAL = 3000; // every 3 seconds
    var POLL_MAX_ATTEMPTS = 10; // for 30 seconds

    var Poll = function(itemIds) {
        var that = this;
        this.intervalId = null;
        this.attempts = 0;
        this.itemIds = itemIds;
        this.pollFn = function() {
            that.attempts++;
            $.el8_ajax({
                type: 'GET',
                url: el8.service.urls.get('getMedOrderFulfillments'),
                data: {'med_order_id': that.itemIds},
                success: function(data) {
                    var stopPoll = true;
                    for(var i=0; i<that.itemIds.length; i++) {
                        var item = el8.ptdata.medOrders.getById(that.itemIds[i]);
                        var info = data[that.itemIds[i]];

                        if (!info.length) { continue; }

                        var currFulfillmentState = item.getFulfillmentMgr().getLatestState();
                        var newFulfillmentState = info[0]['state'];

                        if (currFulfillmentState !== newFulfillmentState) {
                            item.setFulfillmentRequired(true);
                            item.getFulfillmentMgr().loadFulfillments(info);
                            el8.ptdata.medOrders.trigger('updated', item);
                        }
                        // If eRx is still pending, then don't stop polling
                        if (item.getFulfillmentMgr().isLatestERxPending()) {
                            stopPoll = false;
                        }
                    }
                    if (stopPoll || (that.attempts === POLL_MAX_ATTEMPTS)) {
                        that.endPoll();
                    }
                },
                error: function() {
                    that.endPoll();
                }
            });
        };
        this.startPoll = function() {
            var that = this;
            that.intervalId = $.el8_setInterval(function() { that.pollFn(); }, POLL_INTERVAL);
        };
        this.endPoll = function() {
            var that = this;
            $.el8_clearInterval(that.intervalId);
        };
        return this;
    };

    that.addERxPoller = function(itemIds) {
        var poll = new Poll(itemIds);
        poll.startPoll();
    };

    return that;

})();
